<template lang="html">
    <div id="d-page-template-1">

      <section class="short-info-section-s1">
        <div class="box-top">
          <div class="col-sm-6 col-title">
            <h2>Evaluación cuantitativa</h2>
          </div>
          <div class="col-sm-6 col-title"></div>
          <br>
          <div class="box-short-info">
            <div class="col-lg-6 col-inf">
              <h6 class="txt-info"><strong>Puntaje total:</strong> <span>{{ rows[0].total_point }}</span></h6>
            </div>
            <div class="col-lg-6 col-inf">
              <h6 class="txt-info"><strong>Calificación:</strong> <span>{{ rows[0].calification }}</span></h6>
            </div>
          </div>

          <div class="col-lg-6 col-title">
            <div class="row">
                <div class="col-8">
                  <b>Obetivos:</b><br>
                  <p><b>E</b> Específicos (Propios del Puesto)</p>
                  <p><b>G</b> Genéricos (Comunes al Grupo de Trabajo)</p>
                  <p><b>P</b> Personales (Relativos al Ocupante)</p>
                </div>
                <div class="col-4">
                  <b>Peso</b><br>
                  <p><b>Deberán</b> </p>
                  <p><b>Sumar</b></p>
                  <p><b>100 puntos</b></p>
                </div>
            </div>

          </div>
          <div class="col-lg-6 col-title">
            <div class="row">
                <div class="col-7 col-sm-8">
                  <b>Niveles de Desempeño:</b><br>
                  <p><b>(E)Excelente</b> Muy superior a lo requerido</p>
                  <p><b>(SS)Sobresaliente</b> Superior a lo satisfactorio</p>
                  <p><b>(S)Satisfactorio</b> Cumple con lo requerido</p>
                  <p><b>(NS)No Satisfactorio</b> Inferior a lo requerido</p>
                  <p><b>(D)Deficiente</b> Desempeño inaceptable</p>
                </div>
                <div class="col-3 col-sm-3">
                  <b>Calificación</b><br>
                  <p>5 puntos</p>
                  <p>4 puntos</p>
                  <p>3 puntos</p>
                  <p>2 puntos</p>
                  <p>1 punto</p>

                </div>
                <div class="col-2 col-sm-1">
                  <b>%</b><br>
                  <p>100</p>
                  <p>80</p>
                  <p>60</p>
                  <p>40</p>
                  <p>20</p>
                </div>
            </div>
          </div>
        </div>
      </section>

      <section class="requests-section" v-if="!loading">
        <div class="box-results">
          <b-card no-body>
            <b-tabs class="tabs-lg" card>

              <b-card-text>
                <div class="no-gutters post-template-s6" v-for="(v, vInx) in rows" :key="'vInx-'+vInx">
                  <b-card no-body>
                    <b-tabs class="tabs-lg" card>

                      <!-- Para mi area -->
                      <b-tab title="Objetivos" active>
                        <b-card-text>
                          <div class="table-s1">
                            <div class="table-responsive">
                              <table class="table table-sm">
                                <thead class="thead-dark">
                                  <tr>
                                    <th class="c-txt-sm c-tipo">Tipo de objetivo</th>
                                    <th class="c-descr">Descripción</th>
                                    <th>Objetivo</th>
                                    <th class="c-peso">Peso</th>
                                    <th class="c-desemp">Indicador de desempeño</th>
                                    <th>Resultado</th>
                                    <th class="c-califi">Calificación</th>
                                    <th class="c-txt-sm c-puntaje">Puntaje<br />(Peso x Cal.)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(ob, obj) in v.objetives" :key="'obj-'+obj">
                                    <th scope="row">{{ ob.type }}</th>
                                    <td class="c-descr">{{ ob.description }}</td>
                                    <td>{{ ob.objetive }}</td>
                                    <td>{{ ob.weight }}</td>
                                    <td class="c-desemp">{{ ob.performance_indicator }}</td>
                                    <td>{{ ob.result }}</td>
                                    <td>{{ ob.calificacion }}</td>
                                    <td>{{ ob.score }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <!-- <div class="box-content" v-for="(ob, obj) in v.objetives" :key="'obj-'+obj">
                            <div class="box-info-cols">
                              <div class="row _row">
                                <div class="col-1 col-info">
                                  <h6 class="title">Tipo de objetivo</h6>
                                  <p class="f-w-700">{{ob.type}}</p>
                                </div>

                                <div class="col-2 col-info">
                                  <h6 class="title">Descripción:</h6>
                                  <p class="f-w-700">{{ob.description}}</p>
                                </div>

                                <div class="col-2 col-info">
                                  <h6 class="title">Objetivo:</h6>
                                  <p class="f-w-700">{{ob.objetive}}</p>
                                </div>

                                <div class="col-1 col-info">
                                  <h6 class="title">Peso:</h6>
                                  <p class="f-w-700">{{ob.weight}}</p>
                                </div>

                                <div class="col-2 col-info">
                                  <h6 class="title">Indicador de desempeño:</h6>
                                  <p class="f-w-700">{{ob.performance_indicator}}</p>
                                </div>

                                <div class="col-2 col-info">
                                  <h6 class="title">Resultado:</h6>
                                  <p class="f-w-700">{{ob.result}}</p>
                                </div>

                                <div class="col-1 col-info">
                                  <h6 class="title">Calificacion:</h6>
                                  <p class="f-w-700">{{ob.calificacion}}</p>
                                </div>

                                <div class="col-1 col-info">
                                  <h6 class="title">Puntaje:</h6>
                                  <p class="f-w-700">{{ob.score}}</p>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </b-card-text>
                      </b-tab>

                      <b-tab title="Resultados">
                        <b-card-text>
                          <div class="box-content" >
                            <div class="box-info-cols">
                              <div class="row _row py-4 px-3">
                                    <div class="col-12">
                                      <div class="table-s1">
                                        <table class="table table-sm mb-0">
                                          <thead class="thead-dark">
                                            <tr>
                                              <th>Lim inf</th>
                                              <th>Lim sup</th>
                                              <th>Calificación</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <th>
                                                <p>0</p>
                                                <p>151</p>
                                                <p>251</p>
                                                <p>351</p>
                                                <p>451</p>
                                              </th>
                                              <td>
                                                <p>150</p>
                                                <p>250</p>
                                                <p>350</p>
                                                <p>450</p>
                                                <p>500</p>
                                              </td>
                                              <td>
                                                <p>Deficiente</p>
                                                <p>No satidfactorio</p>
                                                <p>Satisfactorio</p>
                                                <p>Sobresaliente</p>
                                                <p>Excelente</p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <!-- <div class="col-2" style="text-align: center;">
                                      <b>Lim inf</b><br>
                                      <p>0</p>
                                      <p>151</p>
                                      <p>251</p>
                                      <p>351</p>
                                      <p>451</p>
                                    </div>
                                    <div class="col-2" style="text-align: center;">
                                      <b>Lim sup</b><br>
                                      <p>150</p>
                                      <p>250</p>
                                      <p>350</p>
                                      <p>450</p>
                                      <p>500</p>
                                    </div>
                                    <div class="col-3" style="text-align: center;">
                                      <b>Calificación</b><br>
                                      <p>Deficiente</p>
                                      <p>No satidfactorio</p>
                                      <p>Satisfactorio</p>
                                      <p>Sobresaliente</p>
                                      <p>Excelente</p>
                                    </div> -->
                                    <!-- <div class="col-5 text-center">
                                      <h6 class="title">Puntaje total:</h6>
                                      <p class="f-w-700">{{v.total_point}}</p>

                                      <h6 class="mt-4 title">Calificación:</h6>
                                      <p class="f-w-700">{{v.calification}}</p>
                                    </div> -->

                                <div class="col-12 col-info"><hr></div>
                                <div class="col-12 col-info">
                                  <h6 class="title">Acciones para desarrollar fortalezas identificadas en el desempeño:</h6>
                                  <p class="f-w-600">{{v.actions}}</p>
                                </div>
                                <div class="col-12 col-info"><hr></div>
                                <div class="col-12 col-info">
                                  <h6 class="title">Sugerencias para mejorar el áreas de oportunidad:</h6>
                                  <p class="f-w-600">{{v.suggestion}}</p>
                                </div>
                                <div class="col-12 col-info"><hr></div>

                                <div class="col-12 col-info">
                                  <h6 class="title">Plan de desarrollo:</h6>
                                  <p class="f-w-600">{{v.development_plan}}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card>

                </div>
              </b-card-text>

            </b-tabs>
          </b-card>
        </div>
      </section>

    </div>
  </template>


  <script>
  export default {
    data() {
      return {
        formSearch: {
          keywords: null
        },
        rows:[],
        others:[],
      }
    },

    methods: {
      onSubmit(event) {
        event.preventDefault();
      },
      getRows(){
        axios.get(tools.url("/api/quantitative")).then((response)=>{
            this.rows = response.data;

        }).catch(()=>{});
      }
    },
    mounted(){
        this.getRows();
    }
  }
  </script>
